import React from 'react';
import CSidebarButtonBase, { type CSidebarButtonBaseProps } from './CSidebarButtonBase';
import { Link } from 'react-router-dom';

interface CSidebarButtonLinkProps extends Omit<CSidebarButtonBaseProps, 'onClick'> {
  to: string;
}

export default function CSidebarButtonLink(props: CSidebarButtonLinkProps) {
  return (
    <Link to={props.to} style={{color: 'inherit'}}>
      <CSidebarButtonBase {...props}>
        {props.children}
      </CSidebarButtonBase>
    </Link>
  );
}
